import MSFmultiSelect from '../../libs/bootstrap-select/bootstrap-select';
import mapboxgl from 'mapbox-gl';

/**
 * MapOmraden
 * Functions for the map
 * @version 1.0.0
 * @exports MapOmraden
 * */
export default class MapOmraden {
    constructor() {
        this._multiSelect();
        this._initMapBox();
    }

    _multiSelect() {
        $('#omraden').selectpicker('refresh');
        $('#omraden').selectpicker('setStyle', 'btn');

        document.querySelector('.bootstrap-select .btn.dropdown-toggle').addEventListener('keydown', (event) => {
            if (event.keyCode === 32) {
                console.log('woho');
                $('#omraden').selectpicker('toggle');
            }
        });
    }

    _initMapBox() {
        var request = new XMLHttpRequest();
        request.open("GET", "/umbraco/surface/map/gettoken");

        request.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {
                mapboxgl.accessToken = this.responseText;

                var map = new mapboxgl.Map({
                    container: 'map',
                    style: 'mapbox://styles/mapbox/streets-v11',
                    center: [mapBoxConfig.centerLng, mapBoxConfig.centerLat], // starting position [lng, lat]
                    zoom: mapBoxConfig.zoom,
                    dragPan: true,
                    scrollZoom: false
                });

                // Add zoom and rotation controls to the map.
                map.addControl(new mapboxgl.NavigationControl());

                var geojson = mapBoxConfig.geojson;
                var selected = mapBoxConfig.selected;
                var readMoreString = mapBoxConfig.readMoreString;

                // add markers to map
                geojson.features.forEach(function (marker) {
                    // create a HTML element for each feature
                    var el = document.createElement('div');

                    if (selected != null && !selected.includes(marker.properties.id)) {
                        el.className = 'marker-filtered';
                    }
                    else {
                        el.className = 'marker';
                    }

                    var popup = new mapboxgl.Popup({ offset: 25 }).setHTML('<a class="mapboxgl-popup-link" href="' + marker.properties.url + '#map-wrapper"><div class="mapboxgl-popup-heading">' + marker.properties.title + '</div>' +
                        '<p class="mapboxgl-popup-description">' + marker.properties.description + '</p>' +
                        '<div class="btn btn-link btn-more">' + mapBoxConfig.readMoreString + '<span class="mi mi-arrow-forward"></span></div></a>');

                    // make a marker for each feature and add to the map
                    new mapboxgl.Marker(el)
                        .setLngLat(marker.geometry.coordinates)
                        .setPopup(popup)
                        .addTo(map);

                    el.addEventListener('click', function (e) {
                        var that = this;
                        // get all the elements with class "marker selected"
                        var x = document.getElementsByClassName("marker-selected");
                        var i;
                        for (i = 0; i < x.length; i++) {
                            x[i].className = "marker"; // set "marker" as the class for each of those elements
                        }
                        // at this point all markers are back to the original state

                        // now you set the class of the current clicked marker
                        this.className = 'marker-selected';

                        popup.on('close', function (e) {
                            that.className = 'marker';
                        });
                        map.flyTo({
                            center: marker.geometry.coordinates
                        });
                    });
                });
            }
        };

        request.send();
    }
}